module.exports = {
	"Aggressive Allocation": 19,
	"China Region": 1,
	"Commodities Focused": 1,
	"Communications": 26,
	"Consumer Cyclical": 38,
	"Consumer Defensive": 16,
	"Diversified Emerging Mkts": 6,
	"Diversified Pacific/Asia": 6,
	"Energy Limited Partnership": 27,
	"Equity Energy": 52,
	"Equity Precious Metals": 30,
	"Europe Stock": 35,
	"Financial": 52,
	"Foreign Large Blend": 275,
	"Foreign Large Growth": 121,
	"Foreign Large Value": 142,
	"Foreign Small/Mid Blend": 26,
	"Foreign Small/Mid Growth": 38,
	"Foreign Small/Mid Value": 27,
	"Global Aggressive Allocation": 27,
	"Global Large-Stock Blend": 134,
	"Global Large-Stock Growth": 90,
	"Global Large-Stock Value": 60,
	"Global Moderate Allocation": 64,
	"Global Moderately Aggressive Allocation": 40,
	"Global Moderately Conservative Allocation": 2,
	"Global Real Estate": 52,
	"Global Small/Mid Stock": 60,
	"Health": 87,
	"Industrials": 46,
	"Infrastructure": 45,
	"Japan Stock": 27,
	"Large Blend": 618,
	"Large Growth": 402,
	"Large Value": 440,
	"Mid-Cap Blend": 208,
	"Mid-Cap Growth": 170,
	"Mid-Cap Value": 165,
	"Miscellaneous Allocation": 4,
	"Miscellaneous Region": 43,
	"Miscellaneous Sector": 27,
	"Moderate Allocation": 103,
	"Moderately Aggressive Allocation": 35,
	"Moderately Conservative Allocation": 3,
	"Natural Resources": 76,
	"Pacific/Asia ex-Japan Stk": 5,
	"Real Estate": 92,
	"Small Blend": 247,
	"Small Growth": 150,
	"Small Value": 165,
	"Tactical Allocation": 22,
	"Target-Date 2025": 9,
	"Target-Date 2030": 33,
	"Target-Date 2035": 38,
	"Target-Date 2040": 42,
	"Target-Date 2045": 43,
	"Target-Date 2050": 43,
	"Target-Date 2055": 42,
	"Target-Date 2060": 42,
	"Target-Date 2065+": 62,
	"Technology": 174,
	"Utilities": 26
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersPeers.json
// module id = 966
// module chunks = 0